import React from "react";
import { Breadcrumbs } from "../../components/elements/Breadcrumbs/Breadcrumbs";
import { Breadcrumbs as BreadcrumbsType } from "./PageTypes";
import * as styles from "./PageBreadcrumbs.module.css";

interface Props {
  breadcrumbs?: BreadcrumbsType;
}

export const PageBreadcrumbs: React.FC<Props> = ({ breadcrumbs }) => {
  if (!breadcrumbs?.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Breadcrumbs breadcrumbs={breadcrumbs} style="white" />
    </div>
  );
};
